export const CATALOGUE_PAGE_SIZE = 12;

const categoryName = (item) => {
  if (typeof item === 'string') {
    return item.trim();
  }
  if (!item || typeof item !== 'object') {
    return '';
  }
  return String(item.category || item.name || item.label || '').trim();
};

/** Sidebar names in API order. Counts are the full catalogue totals, not this page. */
export const catalogueCategories = (response) => {
  const data = Array.isArray(response?.data) ? response.data : [];
  const counts = new Map();
  data.forEach((item) => {
    const name = categoryName(item);
    if (!name) {
      return;
    }
    const count = Number(item?.count);
    counts.set(name, Number.isFinite(count) ? count : 0);
  });

  const fromFilters = Array.isArray(response?.filters?.categories)
    ? response.filters.categories.map(categoryName).filter(Boolean)
    : [];
  const names = fromFilters.length
    ? fromFilters
    : data.map(categoryName).filter(Boolean);

  return names.map((name) => ({
    category: name,
    count: counts.has(name) ? counts.get(name) : 0,
  }));
};

/** Full catalogue size: sum of each category's count, not the current page. */
export const catalogueTotalCount = (categories = []) => (
  categories.reduce((sum, item) => sum + (Number(item?.count) || 0), 0)
);

export const catalogueCourses = (response) => (
  Array.isArray(response?.courses) ? response.courses : []
);

export const catalogueQuery = ({ category, pageno = 0, perpage = CATALOGUE_PAGE_SIZE } = {}) => {
  const pageIndex = Number(pageno);
  const params = {
    pageno: Number.isFinite(pageIndex) && pageIndex >= 0 ? pageIndex : 0,
    perpage,
  };
  if (category) {
    params.category = category;
  }
  return params;
};

export const cataloguePagination = (pagination, courses = []) => {
  const pageno = Number(pagination?.pageno);
  const pageIndex = Number.isFinite(pageno) && pageno >= 0 ? pageno : 0;
  const perpage = Number(pagination?.perpage) > 0 ? Number(pagination.perpage) : CATALOGUE_PAGE_SIZE;
  const dataCount = Number(pagination?.data_count);
  const count = Number.isFinite(dataCount) ? dataCount : courses.length;
  let totalPages = Number(pagination?.total_pages);
  if (!Number.isFinite(totalPages) || totalPages < 0) {
    totalPages = count > 0 ? Math.ceil(count / perpage) : 0;
  }
  const hasNext = pagination?.has_next != null
    ? !!pagination.has_next
    : pageIndex < totalPages - 1;
  return {
    pageno: pageIndex,
    perpage,
    data_count: count,
    total_pages: totalPages,
    has_next: hasNext,
  };
};
